$(document).ready(function(){
  if ( $('body.multiple_shipping_addresses').length ) {
    var container = '<div class="container"></div>';
    $('#main .woocommerce').append(container);
    $('#address_form').appendTo('#main .woocommerce .container');

    jQuery('.country_select').select2();
    jQuery('.state_select').select2();
    $('.add_address').click(function(){
      jQuery('select.country_select').select2();
      jQuery('select.state_select').select2();
    });
  }
});